import { usePowerSyncContext } from "@/providers/power-sync-context";
import { useDrizzle } from "@/hooks/use-drizzle";
import { useSession } from "@/lib/auth";
import { useI18n } from "@/providers/i18n-provider";

/**
 * Shared context for gym screens: PowerSync db + Drizzle + userId + i18n.
 * Avoids repeating the same quartet of hooks on each page.
 */
export function useGymCtx() {
  const { db } = usePowerSyncContext();
  const drizzle = useDrizzle();
  const session = useSession();
  const { t, locale } = useI18n();

  return {
    db,
    drizzle,
    userId: () => session.userId() || undefined,
    t,
    locale,
  };
}
